var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-assignee-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [
          _vm._v(_vm._s(_vm.$t("taskModuleRules.assignmentMethod"))),
        ]),
        _vm._v(" "),
        _c(
          "a-radio-group",
          {
            attrs: { "button-style": "solid" },
            on: { change: _vm.onMethodChange },
            model: {
              value: _vm.localConfig.method,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "method", $$v)
              },
              expression: "localConfig.method",
            },
          },
          [
            _c("a-radio-button", { attrs: { value: "static" } }, [
              _vm._v(_vm._s(_vm.$t("taskModuleRules.static"))),
            ]),
            _vm._v(" "),
            _c("a-radio-button", { attrs: { value: "algorithmic" } }, [
              _vm._v(_vm._s(_vm.$t("taskModuleRules.algorithmic"))),
            ]),
            _vm._v(" "),
            _c("a-radio-button", { attrs: { value: "random" } }, [
              _vm._v(_vm._s(_vm.$t("taskModuleRules.random"))),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.localConfig.method === "static"
      ? _c("div", { staticClass: "static-config" }, [
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.users")))]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    mode: "multiple",
                    placeholder: _vm.$t("taskModuleRules.selectUsers"),
                  },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.userList,
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig, "userList", $$v)
                    },
                    expression: "localConfig.userList",
                  },
                },
                _vm._l(_vm.users, function (user) {
                  return _c(
                    "a-select-option",
                    { key: user._id, attrs: { value: user._id } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(user.name) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.localConfig.method === "algorithmic"
      ? _c("div", { staticClass: "algorithmic-config" }, [
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.userList")))]),
              _vm._v(" "),
              _c(
                "a-checkbox",
                {
                  on: { change: _vm.onUseAllUsersChange },
                  model: {
                    value: _vm.localConfig.useAllUsers,
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig, "useAllUsers", $$v)
                    },
                    expression: "localConfig.useAllUsers",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("taskModuleRules.allUsers")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.localConfig.useAllUsers
            ? _c(
                "div",
                { staticClass: "config-field" },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        mode: "multiple",
                        placeholder: _vm.$t("taskModuleRules.selectUsers"),
                      },
                      on: { change: _vm.emitChange },
                      model: {
                        value: _vm.localConfig.userList,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig, "userList", $$v)
                        },
                        expression: "localConfig.userList",
                      },
                    },
                    _vm._l(_vm.users, function (user) {
                      return _c(
                        "a-select-option",
                        { key: user._id, attrs: { value: user._id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(user.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("taskModuleRules.algorithm"))),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.algorithmSettings.algorithm,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localConfig.algorithmSettings,
                        "algorithm",
                        $$v
                      )
                    },
                    expression: "localConfig.algorithmSettings.algorithm",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "least_task" } }, [
                    _vm._v(_vm._s(_vm.$t("taskModuleRules.leastTask"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "round_robin" } }, [
                    _vm._v(_vm._s(_vm.$t("taskModuleRules.roundRobin"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("taskModuleRules.dateRange"))),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.algorithmSettings.dateRange,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localConfig.algorithmSettings,
                        "dateRange",
                        $$v
                      )
                    },
                    expression: "localConfig.algorithmSettings.dateRange",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "today" } }, [
                    _vm._v(_vm._s(_vm.$t("taskModuleRules.today"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "last_7_days" } }, [
                    _vm._v(_vm._s(_vm.$t("taskModuleRules.last7Days"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "last_30_days" } }, [
                    _vm._v(_vm._s(_vm.$t("taskModuleRules.last30Days"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c(
                "a-checkbox",
                {
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.algorithmSettings.checkOnlineStatus,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localConfig.algorithmSettings,
                        "checkOnlineStatus",
                        $$v
                      )
                    },
                    expression:
                      "localConfig.algorithmSettings.checkOnlineStatus",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("taskModuleRules.includeOnlyOnlineUsers")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.localConfig.method === "random"
      ? _c("div", { staticClass: "random-config" }, [
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.userList")))]),
              _vm._v(" "),
              _c(
                "a-checkbox",
                {
                  on: { change: _vm.onUseAllUsersChange },
                  model: {
                    value: _vm.localConfig.useAllUsers,
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig, "useAllUsers", $$v)
                    },
                    expression: "localConfig.useAllUsers",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("taskModuleRules.allUsers")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.localConfig.useAllUsers
            ? _c(
                "div",
                { staticClass: "config-field" },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        mode: "multiple",
                        placeholder: _vm.$t("taskModuleRules.selectUsers"),
                      },
                      on: { change: _vm.emitChange },
                      model: {
                        value: _vm.localConfig.userList,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig, "userList", $$v)
                        },
                        expression: "localConfig.userList",
                      },
                    },
                    _vm._l(_vm.users, function (user) {
                      return _c(
                        "a-select-option",
                        { key: user._id, attrs: { value: user._id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(user.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }